export default __webpack_public_path__ + "static/media/upload_loader_trans.80ce2396.gif";